"use client";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import useDocumentReady from "~/hooks/use-document-ready";
import { LinkTrackers } from "~/components/reusables/link-trackers";
import StrapiBlocksRenderer from "~/components/reusables/strapi-blocks-renderer";

type Props = {
  picture: string;
  title: string;
  subtitle: string;
  subtitle2: string | undefined;
  link: string;
  cta: string;
  description: any;
  external?: boolean;
};

const EventCard = ({
  picture,
  title,
  subtitle,
  subtitle2,
  link,
  cta,
  description,
  external,
}: Props) => {
  const document = useDocumentReady();
  return (
    <LinkTrackers
      href={link}
      className="relative m-auto w-[350px] md:m-0"
      target={external ? "_blank" : "_self"}
      segmentMsg="Event Clicked"
      segmentOpt={{ section_clicked: "Event card", event_name: title }}
    >
      {document && (
        <motion.div
          className="min-h-full overflow-hidden rounded-lg bg-white pb-10 shadow-xl"
          whileHover={{
            scale: 1.01,
            boxShadow: "0px 4px 24px rgba(27, 28, 29, 0.2)",
            transition: { duration: 0.25, ease: "easeInOut" },
          }}
        >
          <div className="relative h-[150px]">
            <Image
              unoptimized
              src={picture}
              alt={title}
              fill
              className="object-cover"
            />
          </div>
          <div className="px-6 py-4">
            <div className="mb-2 text-lg font-bold">{title}</div>
            <p className="text-xs font-light">{subtitle}</p>
            <p className="mb-3 text-xs font-light">{subtitle2}</p>
            {description && (
              <div className="">
                <StrapiBlocksRenderer content={description} sm />
              </div>
            )}
            <div className="text-link absolute bottom-4 cursor-pointer text-md underline">
              {cta} {">"}
            </div>
          </div>
        </motion.div>
      )}
    </LinkTrackers>
  );
};

export default EventCard;
